import React from 'react';
import { string, bool } from 'prop-types';
import styled from 'styled-components';
import { ChevronRight } from '@core-ds/icons/16';
import { color, fontSize, space } from '@core-ds/primitives';

const BreadcrumbText = styled.h3`
   margin: 0 ${space[2]};
   font-size: ${fontSize[1]};
   font-weight: normal;
   color: ${({ isLeaf }) => (isLeaf ? color.gray8 : color.gray5)};
   transition: all 0.15s ease-in-out;
   white-space: nowrap;
   text-overflow: ellipsis;
   overflow: hidden;
   max-width: ${({ longerWidth }) => (longerWidth ? '25em' : '10em')};
`;

const BreadcrumbLink = styled.a`
   display: flex;
   align-items: center;
   text-decoration: none !important;

   &:hover ${BreadcrumbText} {
      color: ${color.blue};
   }
`;

const Breadcrumb = ({ title, url, isLeaf, hideArrow, longerWidth = false, testid = null }) => {
   return (
      <BreadcrumbLink data-testid={testid} href={url} title={title} alt={title}>
         {hideArrow || <ChevronRight color={color.gray4} />}
         <BreadcrumbText isLeaf={isLeaf} longerWidth={longerWidth}>
            {title}
         </BreadcrumbText>
      </BreadcrumbLink>
   );
};

Breadcrumb.propTypes = {
   title: string.isRequired,
   url: string.isRequired,
   hideArrow: bool.isRequired,
   isLeaf: bool.isRequired,
   testid: string,
   longerWidth: bool,
};

export default Breadcrumb;
